


import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import SigninWidget from "./components/auth/SigninWidget";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./components/auth/authConfig";
import SocioDemographic from './components/pages/SocioDemographic/SocioDemographic';
import BehavioralDistributionIndex from "./components/pages/BehavioralDistribution/BehavioralDistributionIndex";
import DetailsIndex from "./components/pages/Details/DetailsIndex";
import PsychographicIndex from "./components/pages/Psychographic/PsychographicIndex";
import SocioDemographicIndex from "./components/pages/SocioDemographic/SocioDemographicIndex";
const App = () => {
  useEffect(() => {
    localStorage.setItem("historyListFlag", true);
    localStorage.setItem("historyCollapse", false);
  }, []);

  return (
    <MsalProvider instance={msalInstance}>
      <Router>
        <Switch>
          <Route exact path="/" component={SigninWidget} />
          <Route path="/Psychographic" component={PsychographicIndex} />
          <Route path="/BehavioralDistribution" component={BehavioralDistributionIndex} />
          <Route path="/Socio-Demographic-Distribution" component={SocioDemographicIndex} />
          <Route path="/user/:userID" component={DetailsIndex} />
        </Switch>
      </Router>
    </MsalProvider>
  );
};

export default App;